import React from "react";

export default function CheckboxCell({ value, readOnly, onCommit }) {
  const checked = !!value;
  return (
    <div className="cell-display checkbox">
      <input
        type="checkbox"
        className="checkbox-input"
        checked={checked}
        disabled={readOnly}
        onChange={(e) => onCommit(e.target.checked)}
      />
    </div>
  );
}
